import React, { useState, useEffect, useContext } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useMutation, useManualQuery, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import update from "immutability-helper";
import styled from "styled-components";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";

import {
  TENANT_ALL_ROLES_QUERY,
  TENANT_ADD_ROLE_MUTATION,
  TENANT_UPDATE_ROLE_MUTATION,
  TENANT_DELETE_ROLE_MUTATION,
} from "../../graphQL/tenantRole";

import penImg from "../../assets/icons/pen.png";
import trashImg from "../../assets/icons/trash.png";
import AlertDialog from "../../components/AlertDialog.js";

import ManageTenantRolesDialog from "../../components/ManageTenantRolesDialog.js";

import { project_url } from "../../constants/Data";

import Header from "./Header.js";

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    //  paddingTop:theme.spacing(2),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },

  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    // "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
    //   position: "relative",
    //   display: "block",
    // },
    "&.MuiDataGrid-root": {
      //paddingTop:10,
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
}));

function ManageRoles() {
  const navigate = useNavigate();
  const client = useContext(ClientContext);
  const [loadContent, setLoadContent] = useState(false);
  const [pathname] = useState(window.location.pathname);

  const [tenantRolesList, setTenantRolesList] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const [manageDialogData, setManageDialogData] = useState([]);
  const [alertDeleteMsg, setAlertDeleteMsg] = useState([]);
  const [refreshPageData, setRefreshPageData] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("");

  const [pageSize, setPageSize] = useState(20);

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [access, setAccess] = useState(true);
  const [viewAccess, setViewAccess] = useState(false);
  const [addAccess, setAddAccess] = useState(false);
  const [editAccess, setEditAccess] = useState(false);
  const [deleteAccess, setDeleteAccess] = useState(false);

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Roles"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      setAccess(accessData.staffModuleAccess.access);
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');

      if(commonActions.find(a => a == "View"))
        setViewAccess(true)
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true)
      if(commonActions.find(a => a == "Edit"))
        setEditAccess(true)
      if(commonActions.find(a => a == "Delete"))
        setDeleteAccess(true)

      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const [getTenantRolesQuery] = useManualQuery(TENANT_ALL_ROLES_QUERY);
  const [addTenantRolesMutation] = useManualQuery(TENANT_ADD_ROLE_MUTATION);
  const [updateTenantRolesMutation] = useManualQuery(TENANT_UPDATE_ROLE_MUTATION);
  const [deleteTenantRolesMutation] = useManualQuery(TENANT_DELETE_ROLE_MUTATION);

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTenantRolesList())();
  }, [refreshPageData]);

  const getTenantRolesList = async () => {
    const {
      loading: loadingTenantRolesList,
      error: errorTenantRolesList,
      data: dataTenantRolesList,
    } = await getTenantRolesQuery({
      variables: {
        tenantId: parseInt(tenantId),
      },
    });
    if (errorTenantRolesList && errorTenantRolesList.graphQLErrors) {
      if (errorTenantRolesList.graphQLErrors[0].message === "Signature has expired") {
        navigate(`${project_url}/signin`);
      } else {
        setAlertMsg({
          title: "Error",
          msg: errorTenantRolesList.graphQLErrors[0].message,
        });
      }
    } else if (
      !loadingTenantRolesList &&
      dataTenantRolesList &&
      dataTenantRolesList.tenantAllRoleList
    ) {
      setTenantRolesList(dataTenantRolesList.tenantAllRoleList);
      if (dataTenantRolesList.tenantAllRoleList.length !== 0) {
        let latestDateObject = dataTenantRolesList.tenantAllRoleList[0];
        for (const item of dataTenantRolesList.tenantAllRoleList) {
          if (new Date(item.updateDate) > new Date(latestDateObject.updateDate)) {
            latestDateObject = item;
          }
        }
        setLastUpdate(dayFormat(latestDateObject.updateDate));
      }
    }
  };

  const addTenantRole = async values => {
    const {
      loading: loadingAddTenantRole,
      error: errorAddTenantRole,
      data: dataAddTenantRole,
    } = await addTenantRolesMutation({
      variables: {
        tenantId: parseInt(tenantId),
        name: values[0].trim(),
        desc: values[1].trim(),
      },
    });

    if (errorAddTenantRole && errorAddTenantRole.graphQLErrors) {
      setAlertMsg({
        title: "Error",
        msg: errorAddTenantRole.graphQLErrors[0].message,
      });
    } else if (
      !loadingAddTenantRole &&
      dataAddTenantRole &&
      dataAddTenantRole.addTenantRole.tenantRole
    ) {
      setManageDialogData([]);
      setRefreshPageData(!refreshPageData);
    }
  };

  const updateTenantRole = async (values, index) => {
    const {
      loading: loadingUpdateTenantRole,
      error: errorUpdateTenantRole,
      data: dataUpdateTenantRole,
    } = await updateTenantRolesMutation({
      variables: {
        roleId: parseInt(index),
        name: values[0].trim(),
        desc: values[1].trim(),
      },
    });
    if (errorUpdateTenantRole && errorUpdateTenantRole.graphQLErrors) {
      setAlertMsg({
        title: "Error",
        msg: errorUpdateTenantRole.graphQLErrors[0].message,
      });
    } else if (
      !loadingUpdateTenantRole &&
      dataUpdateTenantRole &&
      dataUpdateTenantRole.updateTenantRole.tenantRole
    ) {
      setManageDialogData([]);
      setRefreshPageData(!refreshPageData);
    }
  };

  const checkDeleteStatus = row => {
    if (row.deletable)
      setAlertDeleteMsg({
        title: "Delete Role",
        msg: "This role is used. It cannot be deleted.",
      });
    else
      setAlertDeleteMsg({
        title: "Delete Role",
        type: "deleteConfirmation",
        msg: 'Are you sure you want to delete the "' + row.name + '" role?',
        roleId: row.index,
      });
  };

  const deleteTenantRole = async index => {
    const {
      loading: loadingDeleteTenantRole,
      error: errorDeleteTenantRole,
      data: dataDeleteTenantRole,
    } = await deleteTenantRolesMutation({
      variables: {
        roleId: parseInt(index),
      },
    });
    if (errorDeleteTenantRole && errorDeleteTenantRole.graphQLErrors) {
      setAlertMsg({
        title: "Error",
        msg: errorDeleteTenantRole.graphQLErrors[0].message,
      });
    } else if (
      !loadingDeleteTenantRole &&
      dataDeleteTenantRole &&
      dataDeleteTenantRole.deleteTenantRole
    ) {
      // console.log(dataDeleteTenantRole.deleteTenantRole.response);
      setRefreshPageData(!refreshPageData);
    }
  };

  
  const columns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },

    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        var editFilter = rows.row.editAccess ? "none" : "grayscale(1)";
        var editOpacity = rows.row.editAccess ? 1 : 0.5;
        var editCursor = rows.row.editAccess ? "pointer" : "auto";

        var deleteFilter = rows.row.deleteAccess ? "none" : "grayscale(1)";        
        var deleteOpacity = rows.row.deleteAccess ? 1 : 0.5;        
        var deleteCursor = rows.row.deleteAccess ? "pointer" : "auto";

        return (
          <Box
            pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Edit this role">
              <img
                style={{
                  paddingRight: 15,
                  cursor: editCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: editFilter,
                  opacity: editOpacity,
                }}
                src={penImg}
                onClick={() => rows.row.editAccess ?
                (
                  setManageDialogData({
                    title: "Edit Role",
                    index: rows.row.index,
                    values: [rows.row.name, rows.row.desc],
                    msg: ["Name", "Description"],
                    type: "Edit",
                  })
                )
                :
                ""
                }
              />
            </StyledTooltip>
            <StyledTooltip title="Delete this role">
              <img
                style={{
                  paddingRight: 15,
                  cursor: deleteCursor,
                  paddingTop: 6,
                  height: 24,
                  weight: 24,
                  filter: deleteFilter,
                  opacity: deleteOpacity,
                }}
                src={trashImg}
                onClick={() => rows.row.deleteAccess ? checkDeleteStatus(rows.row) :""}
              />
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  const rows = tenantRolesList.map(tenantRole => ({
    index: tenantRole.roleId,
    name: tenantRole.roleName,
    desc: tenantRole.desc,
    deletable: tenantRole.deletable,
    editAccess : editAccess,
    deleteAccess: deleteAccess,
  }));

  const classes = useStyles();
  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 5,
            paddingBottom: 6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid
            item
            xs={10}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body1" style={{ paddingLeft: 260 }}>
              Manage Roles
            </Typography>
            <Typography variant="h5" style={{ paddingLeft: 10, paddingTop: 3 }}>
              {lastUpdate ? "Last Updated: (" + lastUpdate + ")" : ""}
            </Typography>
          </Grid>

          <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              disabled = {!addAccess ? "disabled" : ""}
              onClick={() =>
                addAccess ? setManageDialogData({title: "Add Role",msg: ["Name", "Description"],type: "Add",}): ""}
            >
              Add
            </Button>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }
  
  if (loadContent)
    if (access)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: "General Settings", link: null },
            { label: "Manage Roles", link: null },
          ]}
        />
        <div className={classes.container}>
          <Box mb={3} />
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
              },
            }}
            getRowId={row => row.index}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 20 } },
            }}
            pageSizeOptions={[20, 50, 100]}
          />

          {alertDeleteMsg.msg && (
            <AlertDialog
              title={alertDeleteMsg.title}
              type={alertDeleteMsg.type}
              contentMsg={alertDeleteMsg.msg}
              closeDialog={() => setAlertDeleteMsg([])}
              deleteAction={() => {
                setAlertDeleteMsg([]);
                deleteTenantRole(alertDeleteMsg.roleId);
              }}
            />
          )}
          {manageDialogData.msg && (
            <ManageTenantRolesDialog
              title={manageDialogData.title}
              values={manageDialogData.values}
              data={tenantRolesList}
              index={manageDialogData.index}
              type={manageDialogData.type}
              contentMsg={manageDialogData.msg}
              closeDialog={() => setManageDialogData([])}
              addEditDialog={values => {
                if (manageDialogData.type === "Edit")
                  updateTenantRole(values, manageDialogData.index);
                if (manageDialogData.type === "Add") addTenantRole(values);
              }}
            />
          )}
        </div>
        {alertMsg.msg && (
          <AlertDialog
            title={alertMsg.title}
            contentMsg={alertMsg.msg}
            closeDialog={() => {
              setAlertMsg([]);
            }}
          />
        )}
      </div>
    );
  
  else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default ManageRoles;
